import { PrivacyPolicies } from '../components/privacyPolicy/PrivacyPolicies';
import { PrivacyPoliciesProvider } from '../providers';

export const PrivacyPoliciesPage = () => (
  <PrivacyPoliciesProvider>
    <PrivacyPolicies />
  </PrivacyPoliciesProvider>
);
